module.exports = "/images/414def872aa41632f3415545616f970a.svg";